import { green, red, orange } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import { withStyles } from "@material-ui/core/styles";

const ButtonSave = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(green[500]),
    fontSize: 12,
    padding: "2px 2px",
    margin: "5px",
    backgroundColor: green[500],
    "&:hover": {
      backgroundColor: green[700],
    },
  },
}))(Button);

const ButtonUpdate = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(orange[500]),
    fontSize: 12,
    padding: "2px 2px",
    margin: "5px",
    backgroundColor: orange[500],
    "&:hover": {
      backgroundColor: orange[700],
    },
  },
}))(Button);

const ButtonCancel = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(theme.palette.primary.dark), // Garante contraste adequado
    fontSize: 12,
    padding: "2px 2px",
    margin: "5px",
    backgroundColor: theme.palette.primary.dark,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
}))(Button);

const ButtonDelete = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(red[500]),
    fontSize: 12,
    padding: "2px 2px",
    margin: "5px",
    backgroundColor: red[500],
    "&:hover": {
      backgroundColor: red[700],
    },
  },
}))(Button);

export { ButtonSave, ButtonCancel, ButtonDelete, ButtonUpdate };
